/** Let axios set multipart boundary (do not send Content-Type: multipart/form-data alone). */
export const multipartFormConfig = {
  transformRequest: [
    (data, headers) => {
      if (data instanceof FormData) {
        delete headers['Content-Type'];
      }
      return data;
    },
  ],
};

const LEARN_PDF_ERROR_HINTS = {
  PDF_FILE_REQUIRED: 'Choose a PDF file to upload.',
  PDF_INVALID_EXTENSION: 'Only .pdf files are supported.',
  PDF_INVALID_MIME: 'That file is not a valid PDF.',
  PDF_READ_FAILED: 'Could not read the file. Try again.',
  PDF_PARSE_FAILED: 'Could not parse this PDF. It may be encrypted or corrupted.',
  PDF_DUPLICATE_SUSPECTED: 'This PDF was already imported into this notebook.',
  PDF_FILE_SIZE_EXCEEDED: 'PDF exceeds your plan size limit.',
  PDF_PAGE_LIMIT_EXCEEDED: 'PDF exceeds your plan page limit.',
  PDF_UPLOAD_QUOTA_EXCEEDED:
    'You have reached your monthly PDF import limit for your plan. Upgrade to Pro for a higher limit, or try again next month.',
  PDF_CONCURRENT_JOBS_LIMIT: 'Wait for your current import to finish before starting another.',
  PDF_STORAGE_FAILED: 'Server could not store the file. Ensure the API has write access to its upload directory.',
};

/** Pull machine codes like PDF_UPLOAD_QUOTA_EXCEEDED from RFC 7807 detail strings. */
export function extractLearnErrorCode(raw) {
  if (!raw || typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (LEARN_PDF_ERROR_HINTS[trimmed]) return trimmed;
  const quoted = trimmed.match(/"([A-Z][A-Z0-9_]+)"/);
  if (quoted?.[1] && LEARN_PDF_ERROR_HINTS[quoted[1]]) return quoted[1];
  const token = trimmed.match(/\b(PDF_[A-Z0-9_]+)\b/);
  if (token?.[1] && LEARN_PDF_ERROR_HINTS[token[1]]) return token[1];
  return null;
}

export function apiErrorMessage(error, fallback = 'Request failed') {
  const data = error?.response?.data;
  let raw = '';
  if (typeof data === 'string' && data.trim()) raw = data.trim();
  else if (data?.detail) raw = String(data.detail);
  else if (data?.message) raw = String(data.message);
  else if (data?.error) raw = String(data.error);
  else if (data?.description) raw = String(data.description);
  else if (error?.response?.statusText) raw = String(error.response.statusText);
  else if (error?.message) raw = String(error.message);

  const code = extractLearnErrorCode(raw);
  if (code) return LEARN_PDF_ERROR_HINTS[code];

  if (raw && LEARN_PDF_ERROR_HINTS[raw]) return LEARN_PDF_ERROR_HINTS[raw];
  if (raw) return raw;
  return fallback;
}
